import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import VuexRouterSync from 'vuex-router-sync';


VuexRouterSync.sync(store, router);

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    //'AIzaSyAOO40EIn-379MAbB4D4uRqtljQbQJupN8'
    key: 'AIzaSyB8XaZbFYykQlXT36z4tINM_7jyJDmhvhI',
    libraries: 'places,marker',
    // OR: libraries: 'places,drawing',
    // OR: libraries: 'places,drawing,visualization',
    //async: true,
    //defer: true,
    v: 'weekly',
  },
  //autobindAllEvents: true,

  // Demonstrating how we can customize the name of the components
  installComponents: true,
});

import {BootstrapVue,IconsPlugin,TablePlugin} from 'bootstrap-vue'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(TablePlugin)


import SequentialEntrance from "vue-sequential-entrance";
import "vue-sequential-entrance/vue-sequential-entrance.css";
Vue.use(SequentialEntrance);

// Vue.use(createPopper)
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

import '@/assets/css/nucleo-icons.css'
import '@/assets/css/nucleo-svg.css'
import '@/assets/css/soft-ui-dashboard.css'
// import 'vue-material-design-icons/styles.css'

import VueEasyTable from 'vue-easytable'
Vue.use(VueEasyTable)

//#additional vue element ui
//https://element.eleme.io/#/en-US/component/quickstart
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale });
//#end


//vue-excel
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

import '@/plugins.js'
new Vue({
  router,store,
  el: '#app', //add vue element ui
  render: h => h(App),
}).$mount('#app')
